import React, { useEffect, useState } from "react";
import "./AllCourses.css";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../../../../Firebase";
import CardsCours from "../../../../Component/CardsCours/CardsCours";
import Approuve from "./Composant/Approuve";
import Attente from "./Composant/Attente";
import All from "./Composant/All";
import { FcApproval } from "react-icons/fc";
import { GiBookmark } from "react-icons/gi";
import { VscIssueReopened, VscProject } from "react-icons/vsc";

function AllCourses() {
  const [myCours, setMyCours] = useState([]);

  const reftabCours = query(collection(db, "cours"));

  const getUsers = () => {
    onSnapshot(reftabCours, (item) => {
      const currentUserId = sessionStorage.getItem("user_id");
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });

      setMyCours(
        data.filter(
          (elts) =>
            elts.admin_id === currentUserId || elts.created_by === currentUserId
        )
      );
    });
  };

  useEffect(() => {
    getUsers();
  }, []);

  const [filter, setFilter] = useState("");
  const handelChange = (e) => {
    setFilter(e.target.value);
  };

  const allCourses = myCours.filter((item) => item.isArchived === false);
  const coursesApro = myCours.filter(
    (item) => item.isApproved === true && item.isArchived === false
  );
  const coursesNonApro = myCours.filter(
    (item) => item.isApproved === false && item.isArchived === false
  );
  const coursesRejeter = myCours.filter((item) => item.isArchived === true);

  const cardData = [
    {
      cours: "Tous les cours",
      texte: allCourses.length === 1 ? "Cours non rejeté" : "Cours non rejetés",
      icon: <GiBookmark />,
      total: allCourses.length,
      nombre: myCours.length,
      couleur: "#754ffe",
    },
    {
      cours: coursesApro.length === 1 ? "Approuvé" : "Approuvés",
      texte: allCourses.length === 1 ? "Cours non rejeté" : "Cours non rejetés",
      icon: <FcApproval />,
      total: allCourses.length,
      nombre: coursesApro.length,
      couleur: "green",
    },
    {
      cours: coursesNonApro.length === 1 ? "En attente" : "En attente",
      texte: coursesRejeter.length === 1 ? "Cours rejeté" : "Cours rejetés",
      icon: <VscIssueReopened />,
      total: coursesRejeter.length,
      nombre: coursesNonApro.length,
      couleur: "blue",
    },
  ];
  return (
    <div className="container-fluid " id="allCourses">
      <Row>
        {cardData.map(
          ({ cours, texte, icon, nombre, couleur, total }, index) => (
            <>
              <Col lg={4} md={6} key={index}>
                <CardsCours
                  cours={cours}
                  icon={icon}
                  nombre={nombre}
                  couleur={couleur}
                  texte={texte}
                  total={total}
                  key = {index}
                />
              </Col>
            </>
          )
        )}
      </Row>

      <Tabs
        defaultActiveKey="cours"
        transition={false}
        id="justify-tab-center"
        className="mt-4 fw-semibold fs-5 mestab center"
      >
        <Tab eventKey="cours" title="Tous les cours" className="text-dark">
          <All />
        </Tab>
        <Tab eventKey="approuver" title="Approuvés" className="text-dark">
          <Approuve />
        </Tab>
        <Tab eventKey="attente" title="En attente" className="text-dark">
          <Attente />
        </Tab>
      </Tabs>
    </div>
  );
}

export default AllCourses;
